<button type="button" class="btn-reset ion-padding" (click)="selectInfozone(b.infozone)">
  <img  *ngIf="!b.image && b.infozone" [src]="infozonethumbpath(b.infozone)" alt="">

  <div *ngIf="b.image" class="smtileitem-wrapper"
    [ngStyle]="{'background-image': 'url(' + safeURL(mediaUrl(b.image)) + ')'}">
    <h2 class="title-button" expand="full">
      <ion-icon name="information-circle-sharp"></ion-icon>
    </h2>
  </div>
</button>
